import { ReactNode } from "react";
import { Box } from "@mui/material";
import FdButton from "../UIComponents/Button/FdButton";
import FdTypography from "../UIComponents/Typography/FdTypography";
import {emptyScreenStyles as classes} from "./styles"

export const EmptyScreen = ({
    message,
    handleFunc,
    buttonName,
    icon,
  }: {
    message?: string;
    handleFunc?: Function;
    buttonName?: string;
    icon?: ReactNode;
  }) => (
    <Box sx={classes.emptyScreen}>
      <Box sx={{ textAlign: "center" }}>
        {icon &&
        <Box className="iconStyle">{icon}</Box>
        }
        <Box>
          <FdTypography label={message} />
        </Box>
        {buttonName && 
        <Box sx={{ mt: 2 }}>
        <FdButton ButtonName={buttonName} onClick={() =>{
           if(handleFunc) handleFunc()
        }} />
      </Box>
      }
        
      </Box>
    </Box>
  );